import React from "react";
import CEOImg from "../images/ceo-nasir-iqbal.jpg";
import MDImg from "../images/md-liu-qi.jpg";
export default function CEOMessage() {
  return (
    <>
      <div className="ceo-container">
        <h1 className="ceo-title">CEO Message</h1>

        <div className="ceo-content">
          <div className="ceo-image-wrapper">
            <img src={CEOImg} alt="CEO" className="ceo-image" />
          </div>

          <div className="ceo-text-section">
            <div className="ceo-header">
              <div className="ceo-name-box">
                <h2 className="ceo-name">Mr. NASIR IQBAL</h2>
                <p className="ceo-role">CEO & Founder</p>
              </div>
            </div>

            <h3 className="welcome-title">Message</h3>
            <div className="ceo-message">
              <p>
                At Risen Star Goods, we believe that quality and trust are the
                cornerstones of global trade. From our humble beginnings to
                becoming an international supplier of premium food products and
                commodities, our journey has been guided by one simple
                principle: to deliver excellence in every shipment, to every
                partner, in every market we serve. We understand that behind
                every transaction lies a community, a business, and a family
                relying on the consistency and safety of our products. That is
                why we are unwavering in our commitment to ethical sourcing,
                rigorous quality control, and reliable delivery—so that you can
                build with confidence. I extend my sincere gratitude to our
                partners, customers, and team members who have placed their
                trust in us. Together, we are not just trading goods; we are
                nourishing futures and strengthening supply chains worldwide.
                Thank you for being part of our story.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="ceo-container">
        <h1 className="ceo-title">MD Message</h1>

        <div className="ceo-content">
          <div className="ceo-image-wrapper">
            <img src={MDImg} alt="MD" className="ceo-image" />
          </div>

          <div className="ceo-text-section">
            <div className="ceo-header">
              <div className="ceo-name-box">
                <h2 className="ceo-name">Mr. LUI QUI</h2>
                <p className="ceo-role">Managing Director</p>
              </div>
            </div>

            <h3 className="welcome-title">Message</h3>

            <div className="ceo-message">
              <p>
                At Risen Star Goods, our focus has always been to uphold the
                highest standards of quality, reliability, and integrity. As we
                continue to expand our global footprint, we remain committed to
                delivering products that our partners can trust and communities
                can rely on. Each shipment reflects our dedication to
                responsible sourcing, consistent quality, and timely service. I
                am grateful to our valued customers, partners, and team for
                their continued support. Together, we are strengthening supply
                chains and creating lasting impact across the world. Thank you
                for your trust.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
